<template>
  <div class="main">

    <div class="header">
      <div class="title">综合管理平台</div>
      <div class="date">
        <img src="@/assets/date.png" alt="">
        <span class="content">{{date.date}}</span>
        <span class="content">{{date.week}}</span>
        <img src="@/assets/clock.png" alt="">
        <span class="content">{{date.time}}</span>
      </div>
    </div>
    <div class="container">
      <div class="left">
        <div class="device fd-c">
          <div class="title">设备统计</div>
          <div class="content">
            <div id="pie"></div>
            <div class="lis">
              <li>设备总数 <span>{{currentData.device_statistics.total}}<span>台</span></span></li>
              <li>在线数量 <span>{{currentData.device_statistics.online}}<span>台</span></span></li>
              <li>离线数量 <span>{{currentData.device_statistics.offline}}<span>台</span></span></li>
            </div>
          </div>
        </div>
        <div class="ai fd-c">
          <div class="title">消防事件TOP5</div>
          <div class="content" id="alarm_top"></div>
        </div>
        <div class="alarm fd-c">
          <div class="title">近7天告警趋势</div>
          <div class="content" id="alarm_tendency"></div>
        </div>
      </div>
      <div class="center">
        <div class="top">
          <div class="count-top">
            <div id="tag" class="tag animate__fadeInUp animate__animated ">
              <div>
                <span>今日事件数</span>
                <span>{{currentData.today_count.alarm}} <span>件</span> </span>
              </div>
            </div>
            <div id="tag1" class="tag animate__fadeInUp animate__animated ">
              <div>
                <span>今日待处理</span>
                <span>{{currentData.today_count.pending}} <span>件</span> </span>
              </div>
            </div>
            <div id="tag2" class="tag animate__fadeInUp animate__animated ">
              <div>
                <span>今日处理中</span>
                <span>{{currentData.today_count.processing}} <span>件</span> </span>
              </div>
            </div>
            <div id="tag3" class="tag animate__fadeInUp animate__animated ">
              <div>
                <span>今日已处理</span>
                <span>{{currentData.today_count.processed}} <span>件</span> </span>
              </div>
            </div>
          </div>
          <div class="count-b">
            <div class="monitor">
              <img src="@/assets/monitor.png" alt="">
              <div>
                <span>{{currentData.monitor_count.total}}</span>
                <span>监控摄像头</span>
              </div>
            </div>
            <div class="online li">在线 <span>{{currentData.monitor_count.online}}<span>个</span></span></div>
            <div class="offline li">离线 <span>{{currentData.monitor_count.offline}}<span>个</span></span></div>
          </div>
          <img src="@/assets/c_img_1.png" class="img_1" alt="">
          <img src="@/assets/c_img_2.png" class="img_2" alt="">
          <div class="point">
            <span>全国地图</span>
            <span v-if="currentCity"><span style="color:rgba(255, 255, 255, 0.5)">></span> {{currentCity}}</span>
          </div>
          <div class="map animate__animated animate__zoomIn" id="map">

          </div>
          <div v-if="tip_show" id="tooltip" class="tooltip animate__animated animate__fadeInDown">
            <img src="@/assets/close.png" @click="tipClose" class="close" alt="">
            <div class="city">{{currentCity}}</div>
            <div class="label"><span>项目数 :</span><span class="value1">{{tip.project || 0}}个</span></div>
            <div class="label"><span>设备总数 :</span><span class="value2">{{tip.device || 0}}台</span></div>
          </div>
        </div>
        <div class="bottom fd-c">
          <div class="title-c">工单数据<span @click="more('wordData')" class="more">更多</span></div>
          <div class="content">
            <div class="count">
              <div class="count_t">今日工单</div>
              <div class="lis">
                <li>总数 <span>{{currentData.wordOrder_count.total}}<span>个</span></span></li>
                <li>待接单 <span>{{currentData.wordOrder_count.pending}}<span>个</span></span></li>
                <li>处理中 <span>{{currentData.wordOrder_count.processing}}<span>个</span></span></li>
              </div>
            </div>
            <div class="table" @mouseenter="stopAutoScroll" @mouseleave="resumeAutoScroll">
              <el-table @row-click='tableRowClick_alarm' :data="currentData.workOrder_TableData" ref="table" size="mini" style="background:transparent">
                <el-table-column prop="name" align="center" show-overflow-tooltip label="任务名称">
                </el-table-column>
                <el-table-column prop="project" align="center" show-overflow-tooltip label="所属项目">
                </el-table-column>
                <el-table-column prop="business" align="center" show-overflow-tooltip label="所属业务">
                </el-table-column>
                <el-table-column prop="date" align="center" show-overflow-tooltip label="生成时间">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip label="状态">
                  <template slot-scope="{row}">
                    <span style="color:#08a45a">{{row.status}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="task fd-c">
          <div class="title">巡检任务完成率统计</div>
          <div class="content" id="polling"></div>
        </div>
        <div class="warn fd-c">
          <div class="title">消防设备告警统计</div>
          <div class="content">
            <div class="top">
              <div class="alarm_c">
                <img src="@/assets/alarm_c.png" alt="">
                <div>
                  <span><span style="color: #FF961C;
font-family: DINPro;
font-size: 24px;
font-style: normal;
font-weight: 500;
line-height: normal;">{{currentData.fireControl.total}}</span> 次</span>
                  <span> 告警总数</span>
                </div>

              </div>
              <div class="lis">
                <div>消防烟感告警</div>
                <div>消防温度告警</div>
                <div>传感器火警</div>
                <div>其他消防告警</div>
              </div>
            </div>
            <div class="bottom">
              <div>
                <span class="item_t">消防烟感告警</span>
                <div class="bar1 bar" :class="{'广东省':'guangdong1','湖北省':'hubei1','湖南省':'hunan1'}[currentCity]"></div>
                <span class="percent">{{(currentCity?{'广东省':18,'湖北省':25,'湖南省':33}[currentCity]:22) || 0}}%</span>
              </div>
              <div>
                <span class="item_t">传感器火警</span>
                <div class="bar2 bar" :class="{'广东省':'guangdong2','湖北省':'hubei2','湖南省':'hunan2'}[currentCity]"></div>
                <span class="percent">{{(currentCity?{'广东省':18,'湖北省':0,'湖南省':0}[currentCity]:12)|| 0}}%</span>
              </div>
              <div>
                <span class="item_t">消防温度告警</span>
                <div class="bar3 bar" :class="{'广东省':'guangdong3','湖北省':'hubei3','湖南省':'hunan3'}[currentCity]"></div>
                <span class="percent">{{(currentCity?{'广东省':10,'湖北省':0,'湖南省':0}[currentCity]:5) || 0}}%</span>
              </div>
              <div>
                <span class="item_t">其他消防告警</span>
                <div class="bar4 bar" :class="{'广东省':'guangdong4','湖北省':'hubei4','湖南省':'hunan4'}[currentCity]"></div>
                <span class="percent">{{(currentCity?{'广东省':54,'湖北省':75,'湖南省':67}[currentCity]:61) || 0}}%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="monitor fd-c">
          <div class="title">实时监控 <span @click="more('monitor')" class="more">更多</span></div>
          <div class="content">
            <div id="video">
              <div class="time">{{date.date}} {{date.time}}</div>
              <video style="width:100%;height:100%;" type="video/mp4" muted loop :src="currentData.monitor_list[monitorActiveIndex].src" autoplay></video>
              <div class="video_t">
                <div>{{currentData.monitor_list[monitorActiveIndex].name}}</div>
                <img @click="fullScreen" src="@/assets/full.png" alt="">
              </div>
            </div>
            <div class="pagination">
              <img src="@/assets/arrow.png" @click="arrowClick('t')" alt="">
              <div class="round" @click="monitorChange(0)" :class="{active:monitorActiveIndex==0}"></div>
              <div class="round" @click="monitorChange(1)" :class="{active:monitorActiveIndex==1}"></div>
              <div class="round" @click="monitorChange(2)" :class="{active:monitorActiveIndex==2}"></div>
              <img src="@/assets/arrow.png" @click="arrowClick('b')" style="transform:rotate(180deg)" alt="">
            </div>

          </div>
        </div>
      </div>
      <el-dialog title="工单列表" append-to-body :visible.sync="wordDataVisible" class="dialog_workData" width="1496px">
        <div class="dialog_container">
          <div class="count-top">
            <div id="tag" class="tag">
              <div>
                <span>工单总数</span>
                <span>{{currentData.wordOrder_count.total}}</span>
              </div>
            </div>
            <div id="tag1" class="tag">
              <div>
                <span>待接单</span>
                <span>{{currentData.wordOrder_count.pending}}</span>
              </div>
            </div>
            <div id="tag2" class="tag">
              <div>
                <span>处理中</span>
                <span>{{currentData.wordOrder_count.processing}}</span>
              </div>
            </div>
            <div id="tag3" class="tag">
              <div>
                <span>待处理</span>
                <span>{{currentData.wordOrder_count.receiving}}</span>
              </div>
            </div>
            <div id="tag4" class="tag">
              <div>
                <span>已完成</span>
                <span>{{currentData.wordOrder_count.accomplish}}</span>
              </div>
            </div>
            <div id="tag5" class="tag">
              <div>
                <span>已关闭</span>
                <span>{{currentData.wordOrder_count.closed}}</span>
              </div>
            </div>
          </div>
          <div class="table">
            <el-table @row-click="workFlow_rowClick" height="580px" :data="wordFlow_tableData" style="width: 100%">
              <el-table-column show-overflow-tooltip align="center" prop="name" label="任务名称">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="project" label="所属项目">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="business" label="所属业务">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="businessType" label="业务类型">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="planType" label="计划类型">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="date" label="生成时间">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="level" label="优先级">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="status" label="状态">
                <template slot-scope="{row}">
                  <span style="color:#07C160">{{row.status}}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="people" label="执行人">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="isOvertime" label="是否超时">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="closeType" label="关闭类型">
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="row">
                  <div style="color: #31E6F0;">详情</div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination class="pagination" @current-change="handleCurrentChange" :current-page="pagination1.pageIndex" :page-sizes="[5, 10, 20, 30]" :page-size="pagination1.pageSize" layout="total, prev, pager, next, jumper" :total="pagination1.total">
            </el-pagination>
          </div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="wordFlowDetail" append-to-body width="680px" class="dialog2">
        <template slot="title">
          <div class="dialog_t">
            <!-- <img src="@/assets/arrow_r.png" alt=""> -->
            <span>工单详情</span>
          </div>
        </template>
        <div class="dialog_container">
          <div class="flow">
            <div class="title flow_title">工单流程</div>
            <div class="flowItems">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in workOrderDetail" :key="index" :color="['结束'].includes(item.status)?'#5197ff':'#08d5cc'">
                  <div class="flow_container">
                    <div>
                      <span style="margin-right:15px;font-size:16px;">{{item.status}}</span>
                      <span>{{item.date}}</span>
                    </div>
                    <div>{{item.desc}}</div>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
          <div class="info">
            <div class="title info_title">工单信息</div>
            <div class="info_container">
              <!-- <div>工单编号：{{currentWorkOrder.name}}</div> -->
              <div>工单名称：{{currentWorkOrder.name}}</div>
              <div>所属项目：{{currentWorkOrder.project}}</div>
              <div>所属业务：{{currentWorkOrder.business}}</div>
              <div>业务类型：{{currentWorkOrder.businessType}}</div>
              <div>计划类型：{{currentWorkOrder.planType}}</div>
              <div>优先级：{{currentWorkOrder.level}}</div>
              <div>生成时间：{{currentWorkOrder.date}}</div>
              <div>工单状态：{{currentWorkOrder.status}}</div>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog :title="currentData.monitor_list[monitorActiveIndex].name" width="1288px" class="dialog3" append-to-body :visible.sync="monitorVisible">
        <div class="time">{{date.date}} {{date.time}}</div>
        <video style="height: 680px;width:100%;" type="video/mp4" muted loop :src="currentData.monitor_list[monitorActiveIndex].src" autoplay></video>
      </el-dialog>
      <el-dialog title="查看监控" append-to-body class="dialog3" :visible.sync="monitorsVisible" width="1496px">
        <div class="dialog_container">
          <div class="tab">
            <div class="nav">
              <div @click="tabClick(0)" :class="{active:tabActiveIndex==0}">监控设备</div>
              <div @click="tabClick(1)" :class="{active:tabActiveIndex==1}">监控分组</div>
            </div>
            <el-input class="search" v-model="searchVal" placeholder="搜索监控"></el-input>
            <el-tree :current-node-key="tabActiveIndex==0?'A栋B1层栅栏.mp4':'A'" default-expand-all class="tree" node-key="id" :data="tabActiveIndex==0?data:data1" :props="defaultProps" @node-click="handleNodeClick">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <img v-if="node.level!==1" src="../assets/monitorTreeNode.png" alt="">
                <span style="padding-left:8px;margin-bottom:2px;">{{ node.label.replace('.mp4','') }}</span>
              </span>
            </el-tree>
          </div>
          <div class="monitorList" v-if="tabActiveIndex==1">
            <div class="video" v-for="(item,index) in currentMonitorGroup1" :key="index">
              <div class="time" v-if="item">{{date.date}} {{date.time}}</div>
              <div class="name">{{item.replace('.mp4','')}}</div>
              <video style="height:100%;width:100%;" type="video/mp4" muted loop :src="formatSrc(item)" autoplay></video>
            </div>
          </div>
          <div class="monitorList1" v-if="tabActiveIndex==0">
            <div class="time">{{date.date}} {{date.time}}</div>
            <video type="video/mp4" muted loop :src="currentMonitorSrc" autoplay></video>
          </div>
        </div>
        <el-pagination v-if="tabActiveIndex==1" class="pagination" @current-change="handleCurrentChange1" :current-page="pagination.pageIndex" :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
        </el-pagination>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getDate } from '@/utils/date'
import * as echarts from 'echarts';
import '../assets/china'
import cityData from '../assets/data'
export default {
  data() {
    return {
      allData: {},
      currentData: {},
      currentWorkOrder: {},
      wordFlowDetail: false,
      monitorsVisible: false,
      tabActiveIndex: 0,
      searchVal: '',
      monitors: [],
      mapChart: null,
      name: '',
      data: [{
        label: '天鹅湖花园',
        children: []
      }, {
        label: '天鹅湖三期',
      }, {
        label: '燕晗山苑'
      }],
      data1: [{
        label: '天鹅湖花园',
        children: [
          {
            label: '天鹅湖花园A栋',
            id: 'A'
          },
          {
            label: '天鹅湖花园B栋',
            id: 'B'
          },
          {
            label: '天鹅湖花园C栋',
            id: 'C'
          },
          {
            label: '天鹅湖花园D栋',
            id: 'D'
          },
          {
            label: '天鹅湖花园E栋',
            id: 'E'
          },
        ]
      }, {
        label: '天鹅湖三期',
      }, {
        label: '燕晗山苑'
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      currentMonitorSrc: require('../assets/A栋/A栋B1层栅栏.mp4'),
      monitorVisible: false,
      workOrderDetail: [],
      pagination1: {
        total: 0,
        pageIndex: 1,
        pageSize: 10
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 4
      },
      date: {},
      wordDataVisible: false,
      tip: {
        project: '',
        device: '',
      },
      currentMonitorGroup: [],
      monitorActiveIndex: 0,
      tip_show: false,
      mapData: [
        {
          name: '广东',
          project: 30,
          device: 3000,
          address: '123123'
        },
        {
          name: '湖南',
          project: 21,
          device: 1111,
          address: '123123'
        },
        {
          name: '广西',
          project: 11,
          device: 2222,
          address: '123123'
        },
        {
          name: '四川',
          project: 44,
          device: 4444,
          address: '123123'
        },
        {
          name: '湖北',
          project: 55,
          device: 5555,
          address: '123123'
        },
        {
          name: '黑龙江',
          project: 66,
          device: 6666,
          address: '123123'
        },
        {
          name: '山东',
          project: 77,
          device: 7777,
          address: '123123'
        },
      ],
      tableDetail: '',
      scrollInterval: null,
      scrollPosition: '',
      wordFlow_tableData: [],
      currentCity: '',
      currentMonitorGroup1: [],
      currentRegion: 'A',
      monitorList: {
        A: [],
        B: [],
        C: [],
        D: [],
        E: []
      }
    }
  },
  created() {
    const A = require.context('@/assets/A栋', false, /.mp4$/);
    const B = require.context('@/assets/B栋', false, /.mp4$/);
    const C = require.context('@/assets/C栋', false, /.mp4$/);
    const D = require.context('@/assets/D栋', false, /.mp4$/);
    const E = require.context('@/assets/E栋', false, /.mp4$/);
    this.monitorList.A = A.keys().map(item => item.replace('./', ''))
    this.monitorList.B = B.keys().map(item => item.replace('./', ''))
    this.monitorList.C = C.keys().map(item => item.replace('./', ''))
    this.monitorList.D = D.keys().map(item => item.replace('./', ''))
    this.monitorList.E = E.keys().map(item => item.replace('./', ''))
    const monitorLabel = []
    this.monitorList.A.forEach((item) => {
      monitorLabel.push({
        label: item,
        id: item,
        region: 'A'
      })
    })
    this.monitorList.B.forEach(item => {
      monitorLabel.push({
        label: item,
        id: item,
        region: 'B'
      })
    })
    this.monitorList.C.forEach(item => {
      monitorLabel.push({
        label: item,
        id: item,
        region: 'C'
      })
    })
    this.monitorList.D.forEach(item => {
      monitorLabel.push({
        label: item,
        id: item,
        region: 'D'
      })
    })
    this.monitorList.E.forEach(item => {
      monitorLabel.push({
        label: item,
        id: item,
        region: 'E'
      })
    })

    this.data[0].children = monitorLabel
    console.log(this.monitorList)
    this.allData = cityData
    this.currentData = cityData.quanguo
    this.wordFlow_tableData = this.currentData.workOrder_TableData.slice(0, 10)
    this.pagination1.total = this.currentData.workOrder_TableData.length
    this.pagination.total = this.monitorList.A.length
    this.setDate()
    setInterval(() => {
      this.setDate()
    }, 1000);
  },
  mounted() {
    this.init()
    this.animation()
    this.startAutoScroll()
  },
  methods: {
    formatSrc(item) {
      return require(`../assets/${this.currentRegion}栋/${item}`)
    },
    tipClose() {
      this.tip_show = false
      this.currentCity = ''
      this.mapChart.dispatchAction({
        type: 'unselect',
        name: this.name
      })
      this.currentData = this.allData.quanguo

      this.chart1()
      this.chart2()
      this.chart3()
      this.chart4()
    },
    handleNodeClick(data, node) {
      if (!data.id) return
      if (this.tabActiveIndex == 0) {
        this.currentMonitorSrc = require(`../assets/${data.region}栋/${data.label}`)
      } else {
        this.currentRegion = data.id
        switch (data.id) {
          case 'A':
            this.currentMonitorGroup = this.monitorList.A
            break;
          case 'B':
            this.currentMonitorGroup = this.monitorList.B
            break;
          case 'C':
            this.currentMonitorGroup = this.monitorList.C
            break;
          case 'D':
            this.currentMonitorGroup = this.monitorList.D
            break;
          case 'E':
            this.currentMonitorGroup = this.monitorList.E
            break;
        }
        this.pagination.total = this.currentMonitorGroup.length
        this.currentMonitorGroup1 = this.currentMonitorGroup.slice(0, 4)
      }
    },
    tabClick(index) {
      this.tabActiveIndex = index
      if (index == 1) {
        this.currentMonitorGroup1 = this.monitorList.A.slice(0, 4)
      } else {
        this.currentRegion = 'A'
      }
    },
    fullScreen() {
      this.monitorVisible = true
    },
    workFlow_rowClick(row) {
      this.wordFlowDetail = true
      this.currentWorkOrder = row
      if (row.status == '待接单') {
        this.workOrderDetail = [
          {
            status: '派单',
            date: row.date,
            desc: row.people + '刘波已派单'
          },
        ]
      } else if (row.status == '待处理') {
        this.workOrderDetail = [
          {
            status: '接单',
            date: `${new Date(Date.now(row.date.split(' ')[1]) + 550000).toLocaleString()}`,
            desc: row.people + '已接单'
          },
          {
            status: '派单',
            date: row.date,
            desc: '刘波已派单'
          },
        ]
      } else if (row.status == '处理中') {
        this.workOrderDetail = [
          {
            status: '处理',
            date: `${new Date(Date.now(row.date.split(' ')[1]) + 3605000).toLocaleString()}`,
            desc: row.people + '已处理'
          },
          {
            status: '接单',
            date: `${new Date(Date.now(row.date.split(' ')[1]) + 550000).toLocaleString()}`,
            desc: row.people + '已接单'
          },
          {
            status: '派单',
            date: row.date,
            desc: '刘波已派单'
          },
        ]
      } else if (row.status == '已完成') {
        this.workOrderDetail = [
          {
            status: '结束',
            date: `${new Date(Date.now(row.date.split(' ')[1]) + 4855000).toLocaleString()}`,
            desc: '已结束,工单结束'
          },
          {
            status: '评价',
            date: `${new Date(Date.now(row.date.split(' ')[1]) + 4455000).toLocaleString()}`,
            desc: '已评价,评价4星'
          },
          {
            status: '审核',
            date: `${new Date(Date.now(row.date.split(' ')[1]) + 4405000).toLocaleString()}`,
            desc: '刘波已审核'
          },
          {
            status: '处理',
            date: `${new Date(Date.now(row.date.split(' ')[1]) + 3605000).toLocaleString()}`,
            desc: row.people + '已处理'
          },
          {
            status: '接单',
            date: `${new Date(Date.now(row.date.split(' ')[1]) + 550000).toLocaleString()}`,
            desc: row.people + '已接单'
          },
          {
            status: '派单',
            date: row.date,
            desc: '刘波已派单'
          },
        ]
      }
    },
    handleCurrentChange(page) {
      let _page = 0
      if (this.currentData.workOrder_TableData.length % 10 == 0) {
        _page = this.currentData.workOrder_TableData.length / 10
      } else {
        _page = Math.ceil(this.currentData.workOrder_TableData.length / 10)
      }
      if (page == _page) {
        this.wordFlow_tableData = this.currentData.workOrder_TableData.slice((page - 1) * 10)
      } else {
        this.wordFlow_tableData = this.currentData.workOrder_TableData.slice((page - 1) * 10, page * 10)
      }
    },
    handleCurrentChange1(page) {
      let _page = 0
      if (this.currentMonitorGroup.length % 4 == 0) {
        _page = this.currentMonitorGroup.length / 4
      } else {
        _page = Math.ceil(this.currentMonitorGroup.length / 4)
      }
      if (page == _page) {
        this.currentMonitorGroup1 = this.currentMonitorGroup.slice((page - 1) * 4)
      } else {
        this.currentMonitorGroup1 = this.currentMonitorGroup.slice((page - 1) * 4, page * 4)
      }
    },
    arrowClick(direction) {
      if (direction == 't') {
        if (this.monitorActiveIndex > 0) {
          this.monitorActiveIndex -= 1
        }
      } else {
        if (this.monitorActiveIndex < 2) {
          this.monitorActiveIndex += 1
        }
      }
    },
    monitorChange(index) {
      this.monitorActiveIndex = index
    },
    startAutoScroll() {
      const tableWrapper = this.$refs.table.$el.querySelector(".el-table__body-wrapper");
      const scrollHeight = tableWrapper.scrollHeight;
      const scrollStep = 1; // 每次滚动的距离
      const that = this
      this.scrollInterval = null;
      const startScroll = () => {
        that.scrollInterval = setInterval(() => {
          this.scrollPosition += scrollStep;
          if (this.scrollPosition >= scrollHeight) {
            this.scrollPosition = 0;
            tableWrapper.scrollTop = 0; // 滚动到开头位置
          } else {
            tableWrapper.scrollTop = this.scrollPosition;
          }
        }, 50); // 滚动间隔时间，单位为毫秒
      };
      startScroll()
    },
    stopAutoScroll() {
      clearInterval(this.scrollInterval);
    },
    tableRowClick_alarm(row, column, event) {
      this.tableDetail = row
      // this.dialogVisible3 = true
    },
    resumeAutoScroll() {
      this.startAutoScroll()
    },
    weekDate() {
      var dates = [];
      var today = new Date();

      for (var i = 0; i < 7; i++) {
        var date = new Date(today);
        date.setDate(today.getDate() - i);
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var formattedDate = ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2);
        dates.push(formattedDate);
      }

      return dates.reverse();
    },
    animation() {
      this.ani_1()
      this.ani_2()
      this.ani_3()
      this.ani_4()
    },
    ani_1() {
      var animationData = { "v": "5.6.5", "fr": 25, "ip": 0, "op": 50, "w": 202, "h": 95, "nm": "底", "ddd": 0, "assets": [{ "id": "image_0", "w": 73, "h": 78, "u": "images1/", "p": "img_0.png", "e": 0 }, { "id": "image_1", "w": 202, "h": 95, "u": "images1/", "p": "img_1.png", "e": 0 }], "layers": [{ "ddd": 0, "ind": 1, "ty": 2, "nm": "事件总数big.png", "cl": "png", "refId": "image_0", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 1, "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.167, "y": 0.167 }, "t": 0, "s": [43, 40.75, 0], "to": [0, 0.492, 0], "ti": [0, 0, 0] }, { "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.167, "y": 0.167 }, "t": 25, "s": [43, 43.7, 0], "to": [0, 0, 0], "ti": [0, 0.492, 0] }, { "t": 50, "s": [43, 40.75, 0] }], "ix": 2 }, "a": { "a": 0, "k": [36.5, 39, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 50, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 3, "ty": 2, "nm": "底.png", "cl": "png", "refId": "image_1", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [101, 47.5, 0], "ix": 2 }, "a": { "a": 0, "k": [101, 47.5, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 50, "st": 0, "bm": 0 }], "markers": [] };
      var params = {
        container: document.getElementById('tag'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData
      }
      lottie.loadAnimation(params);
    },
    ani_2() {
      var animationData = { "v": "5.6.5", "fr": 25, "ip": 0, "op": 50, "w": 202, "h": 95, "nm": "底", "ddd": 0, "assets": [{ "id": "image_0", "w": 76, "h": 79, "u": "images2/", "p": "img_0.png", "e": 0 }, { "id": "image_1", "w": 202, "h": 95, "u": "images2/", "p": "img_1.png", "e": 0 }], "layers": [{ "ddd": 0, "ind": 2, "ty": 2, "nm": "待处理big.png", "cl": "png", "refId": "image_0", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 1, "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.167, "y": 0.167 }, "t": 0, "s": [43, 41.45, 0], "to": [0, 0.375, 0], "ti": [0, 0, 0] }, { "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.167, "y": 0.167 }, "t": 25, "s": [43, 43.7, 0], "to": [0, 0, 0], "ti": [0, 0.682, 0] }, { "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.167, "y": 0.167 }, "t": 50, "s": [43, 41.45, 0], "to": [0, -0.202, 0], "ti": [0, 0.086, 0] }, { "t": 55, "s": [43, 41.45, 0] }], "ix": 2 }, "a": { "a": 0, "k": [38, 39.5, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 50, "st": -5, "bm": 0 }, { "ddd": 0, "ind": 3, "ty": 2, "nm": "底.png", "cl": "png", "refId": "image_1", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [101, 47.5, 0], "ix": 2 }, "a": { "a": 0, "k": [101, 47.5, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 50, "st": 0, "bm": 0 }], "markers": [] };
      var params = {
        container: document.getElementById('tag1'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData
      };
      lottie.loadAnimation(params);
    },
    ani_3() {
      var animationData = { "v": "5.6.5", "fr": 25, "ip": 0, "op": 50, "w": 202, "h": 95, "nm": "底", "ddd": 0, "assets": [{ "id": "image_0", "w": 68, "h": 71, "u": "images3/", "p": "img_0.png", "e": 0 }, { "id": "image_1", "w": 202, "h": 95, "u": "images3/", "p": "img_1.png", "e": 0 }], "layers": [{ "ddd": 0, "ind": 1, "ty": 2, "nm": "处理中big.png", "cl": "png", "refId": "image_0", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 1, "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.167, "y": 0.167 }, "t": 0, "s": [43, 40.75, 0], "to": [0, 0.492, 0], "ti": [0, 0, 0] }, { "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.167, "y": 0.167 }, "t": 25, "s": [43, 43.7, 0], "to": [0, 0, 0], "ti": [0, 0.492, 0] }, { "t": 50, "s": [43, 40.75, 0] }], "ix": 2 }, "a": { "a": 0, "k": [34, 35.5, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 50, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 4, "ty": 2, "nm": "底.png", "cl": "png", "refId": "image_1", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [101, 47.5, 0], "ix": 2 }, "a": { "a": 0, "k": [101, 47.5, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 50, "st": 0, "bm": 0 }], "markers": [] };
      var params = {
        container: document.getElementById('tag2'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData
      };

      lottie.loadAnimation(params);
    },
    ani_4() {
      var animationData = { "v": "5.6.5", "fr": 25, "ip": 0, "op": 50, "w": 202, "h": 95, "nm": "底", "ddd": 0, "assets": [{ "id": "image_0", "w": 76, "h": 80, "u": "images4/", "p": "img_0.png", "e": 0 }, { "id": "image_1", "w": 202, "h": 95, "u": "images4/", "p": "img_1.png", "e": 0 }], "layers": [{ "ddd": 0, "ind": 1, "ty": 2, "nm": "已完成big.png", "cl": "png", "refId": "image_0", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 1, "k": [{ "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.167, "y": 0.167 }, "t": 0, "s": [43, 40.75, 0], "to": [0, 0.492, 0], "ti": [0, 0, 0] }, { "i": { "x": 0.833, "y": 0.833 }, "o": { "x": 0.167, "y": 0.167 }, "t": 25, "s": [43, 43.7, 0], "to": [0, 0, 0], "ti": [0, 0.492, 0] }, { "t": 50, "s": [43, 40.75, 0] }], "ix": 2 }, "a": { "a": 0, "k": [38, 40, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 50, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 5, "ty": 2, "nm": "底.png", "cl": "png", "refId": "image_1", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [101, 47.5, 0], "ix": 2 }, "a": { "a": 0, "k": [101, 47.5, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "ip": 0, "op": 50, "st": 0, "bm": 0 }], "markers": [] };
      var params = {
        container: document.getElementById('tag3'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData
      };

      var anim;

      anim = lottie.loadAnimation(params);
    },
    setDate() {
      this.date = getDate() || {}
    },
    more(origin) {
      switch (origin) {
        case 'wordData':
          this.wordDataVisible = true
          break;
        case 'inspection':

          break;
        case 'alarm':

          break;
        case 'monitor':
          this.monitorsVisible = true
          break;
      }
    },
    init() {
      this.mapInit1()
      this.chart1()
      this.chart2()
      this.chart3()
      this.chart4()
    },
    chart1() {
      let myChart = echarts.init(document.getElementById('pie'))
      var data = [];
      var color = ['#b2efff', '#00a6ff', '#ff862f', '#00ffe0', '#f6596c', '#5767f9']
      const alarmCounts_options = [
        {
          alarmNum: this.currentData.device_statistics.offline,
          name: '离线'
        },
        {
          alarmNum: this.currentData.device_statistics.online,
          name: '在线'
        }
      ]
      for (var i = 0; i < alarmCounts_options.length; i++) {
        data.push({
          value: alarmCounts_options[i].alarmNum,
          name: alarmCounts_options[i].name,
          itemStyle: {
            normal: {
              // borderWidth: 2,
              // shadowBlur: 8,
              // borderRadius: 20,
              // borderColor: 'transparent',
              // shadowColor: color[i]
            }
          }
        },
          {
            value: .3,
            name: '',
            itemStyle: {
              normal: {
                color: 'transparent',
                borderColor: 'transparent',
                borderWidth: 0
              }
            }
          });
      }
      var seriesOption = [{
        name: '',
        type: 'pie',
        clockWise: false,
        radius: [58, 74],
        hoverAnimation: false,
        center: ['50%', '50%'],
        top: "center",
        itemStyle: {
          normal: {
            label: {
              show: false
            }
          }
        },
        data: data
      }];
      let option = {
        backgroundColor: 'transparent',
        color: color,
        title: {
          text: `  ${Math.ceil((this.currentData.device_statistics.offline / this.currentData.device_statistics.total) * 100)}%`,
          x: '32%',
          y: '36%',
          textStyle: {
            fontSize: 26,
            color: '#FFF'
          },
          subtext: '离线占比',
          subtextStyle: {
            color: '#fff',
            fontSize: 18,
            // textAlign: 'left', // 设置子标题水平居中
          }
        },
        series: seriesOption
      }
      myChart.setOption(option)
      window.addEventListener('resize', myChart.resize);
    },
    chart2() {
      let myChart = echarts.init(document.getElementById('alarm_top'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },

        grid: {
          left: '3%',
          right: '3%',
          bottom: '5%',
          top: '22%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.currentData.event_top.xData,
            axisTick: {
              alignWithLabel: true
            },
            axisTick: {
              show: false, //不显示刻度
            },
            axisLabel: {
              textStyle: {
                color: '#D0DEEE',
                fontSize: 10,
                fontWeight: '500'
              },
              margin: 15
            },
          }
        ],
        yAxis: [
          {
            name: "单位: 次",
            type: 'value',
            min: 0,
            // max: 40,
            splitNumber: 4,
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(108, 128, 151, 0.30)',
                type: 'dashed'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#AAA',
              }
            },

          }
        ],
        series: [
          {
            name: '告警次数',
            type: 'bar',
            barWidth: '26%',
            data: this.currentData.event_top.yData,
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              color: '#fff',
              fontWeight: 600
            },
            itemStyle: {
              color: {
                type: 'linear', // 设置为线性渐变色
                x: 0, // 渐变色起始位置 x 坐标
                y: 0, // 渐变色起始位置 y 坐标
                x2: 0, // 渐变色结束位置 x 坐标
                y2: 1, // 渐变色结束位置 y 坐标
                colorStops: [
                  {
                    offset: 0, // 渐变颜色起始位置
                    color: '#1de5dc', // 起始颜色
                  },
                  {
                    offset: 1, // 渐变颜色结束位置
                    color: '#1986e6', // 结束颜色
                  },
                ],
              },
            }
          }
        ]
      };
      myChart.setOption(option)
      window.addEventListener('resize', myChart.resize);
    },
    chart3() {
      let myChart = echarts.init(document.getElementById('polling'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },

        grid: {
          left: '3%',
          right: '3%',
          bottom: '5%',
          top: '22%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.currentData.polling.xData,
            axisTick: {
              alignWithLabel: true
            },
            axisTick: {
              show: false, //不显示刻度
            },
            axisLabel: {
              textStyle: {
                color: '#D0DEEE',
                fontSize: 10,
                fontWeight: '500'
              },
              margin: 15
            },
          }
        ],
        yAxis: [
          {
            name: "",
            type: 'value',
            min: 0,
            // max: 40,
            splitNumber: 4,
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(108, 128, 151, 0.30)',
                type: 'dashed'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#AAA',
              }
            },

          }
        ],
        series: [
          {
            name: '完成率',
            type: 'bar',
            barWidth: '26%',
            data: this.currentData.polling.yData,
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              color: '#fff',
              fontWeight: 600,
              formatter: (params) => {
                return params.data + '%'
              }
            },
            itemStyle: {
              color: {
                type: 'linear', // 设置为线性渐变色
                x: 0, // 渐变色起始位置 x 坐标
                y: 0, // 渐变色起始位置 y 坐标
                x2: 0, // 渐变色结束位置 x 坐标
                y2: 1, // 渐变色结束位置 y 坐标
                colorStops: [
                  {
                    offset: 0, // 渐变颜色起始位置
                    color: '#1de5dc', // 起始颜色
                  },
                  {
                    offset: 1, // 渐变颜色结束位置
                    color: '#1986e6', // 结束颜色
                  },
                ],
              },
            }
          }
        ]
      };
      myChart.setOption(option)
      window.addEventListener('resize', myChart.resize());
    },
    chart4() {
      let yData = this.currentData.alarm_week.yData,
        xData = this.weekDate(),
        datacoords = [
          {
            coords: [],
          },
        ];
      for (var i = 0; i < xData.length; i++) {
        datacoords[0].coords.push([xData[i], yData[i]]);
      }
      let myChart = echarts.init(document.getElementById('alarm_tendency'))
      let option = {
        animation: true, //控制动画示否开启
        // animationDuration: 3000,
        // animationEasing: "bounceOut", //缓动动画
        // animationThreshold: 8, //动画元素的阈值
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },

        grid: {
          left: '3%',
          right: '3%',
          bottom: '10%',
          top: '18%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.weekDate(),
            axisTick: {
              alignWithLabel: true
            },
            axisTick: {
              show: false, //不显示刻度
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(108, 128, 151, 0.30)',
                type: 'dashed'
              }
            },
            axisLabel: {
              textStyle: {
                color: '#D0DEEE',
                fontSize: 12,
                fontWeight: '500'
              },
              margin: 15
            },
          }
        ],
        yAxis: [
          {
            name: "单位: 次",
            type: 'value',
            min: 0,
            // max: 40,
            splitNumber: 4,
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(108, 128, 151, 0.30)',
                type: 'dashed'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#AAA',
              }
            },

          }
        ],
        series: [
          {
            name: '告警次数',
            type: 'line',
            // barWidth: '26%',
            showSymbol: false, //是否默认展示圆点
            data: yData,
            // label: {
            //   show: false,
            //   position: 'top',
            //   fontSize: 14,
            //   color: '#fff',
            //   fontWeight: 600
            // },
            itemStyle: {
              color: {
                type: 'linear', // 设置为线性渐变色
                x: 0, // 渐变色起始位置 x 坐标
                y: 0, // 渐变色起始位置 y 坐标
                x2: 0, // 渐变色结束位置 x 坐标
                y2: 1, // 渐变色结束位置 y 坐标
                colorStops: [
                  {
                    offset: 0, // 渐变颜色起始位置
                    color: '#1de5dc', // 起始颜色
                  },
                  {
                    offset: 1, // 渐变颜色结束位置
                    color: '#1986e6', // 结束颜色
                  },
                ],
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(221, 236, 253, 0.40)'
                },
                {
                  offset: 0.5,
                  color: 'rgba(44, 134, 240, 0.30)'
                },
                {
                  offset: 1,
                  color: 'rgba(12, 82, 165, 0.00)'
                }
                ], false),
                shadowColor: '',
                shadowBlur: 25
              }
            },
          },
          {
            showSymbol: false,
            name: "",
            type: "lines",
            polyline: true,
            smooth: false,
            coordinateSystem: "cartesian2d",
            zlevel: 1,
            effect: {
              show: true,
              smooth: true,
              period: 3,
              symbolSize: 4,
            },
            lineStyle: {
              color: "#fff",
              width: 1,
              opacity: 0,
              curveness: 0,
              cap: "round",
            },
            data: datacoords,
          },
        ]
      };
      myChart.setOption(option)
      window.addEventListener('resize', myChart.resize);
    },
    mapInit1() {
      const that = this
      let img = document.createElement('img')
      img.src = require('../assets/cover.jpg')
      let myChart = echarts.init(document.getElementById('map'))
      this.mapChart = myChart
      let option = {
        backgroundColor: 'transparent',
        geo: [
          {
            map: 'china',
            aspectScale: 0.75,
            layoutCenter: ["50%", "58.6%"], //地图位置
            layoutSize: '110%',
            roam: false,
            selectedMode: false,
            label: {
              emphasis: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                borderColor: "#132f4e",
                borderWidth: 2,
                shadowColor: "#132f4e",
                shadowOffsetY: 1,
                shadowBlur: 2,
                areaColor: "#132f4e",
              },
              emphasis: {
                borderColor: "#132f4e",
                borderWidth: 2,
                shadowColor: "#132f4e",
                shadowOffsetY: 1,
                shadowBlur: 2,
                areaColor: "#132f4e",
              }
            },
            regions: [{
              name: '南海诸岛',
              itemStyle: {
                areaColor: 'rgba(0, 10, 52, 0)',
                borderColor: 'rgba(0, 10, 52, 0)'
              },
              emphasis: {
                areaColor: 'rgba(0, 10, 52, 0)',
                borderColor: 'rgba(0, 10, 52, 0)'
              }
            }],
            z: 2
          },
          {
            map: 'china',
            aspectScale: 0.75,
            selectedMode: false,
            layoutCenter: ["50%", "57.4%"], //地图位置
            layoutSize: '110%',
            roam: false,
            label: {
              emphasis: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                borderColor: "#2c5377",
                borderWidth: 2,
                shadowColor: "#2c5377",
                shadowOffsetY: 1,
                shadowBlur: 2,
                areaColor: "#2c5377",
              },
              emphasis: {
                borderColor: "#2c5377",
                borderWidth: 2,
                shadowColor: "#2c5377",
                shadowOffsetY: 1,
                shadowBlur: 2,
                areaColor: "#2c5377",
              }
            },
            regions: [{
              name: '南海诸岛',
              itemStyle: {
                areaColor: 'rgba(0, 10, 52, 0)',
                borderColor: 'rgba(0, 10, 52, 0)'
              },
              emphasis: {
                areaColor: 'rgba(0, 10, 52, 0)',
                borderColor: 'rgba(0, 10, 52, 0)'
              }
            }],
            z: 2
          },
          {
            map: 'china',
            aspectScale: 0.75,
            layoutCenter: ["50%", "56.2%"], //地图位置
            layoutSize: '110%',
            roam: false,
            selectedMode: false,
            label: {
              emphasis: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                borderColor: "#46779a",
                borderWidth: 2,
                shadowColor: "#46779a",
                shadowOffsetY: 1,
                shadowBlur: 2,
                areaColor: "#46779a",
              },
              emphasis: {
                borderColor: "#46779a",
                borderWidth: 2,
                shadowColor: "#46779a",
                shadowOffsetY: 1,
                shadowBlur: 2,
                areaColor: "#46779a",
              }
            },
            regions: [{
              name: '南海诸岛',
              itemStyle: {
                areaColor: 'rgba(0, 10, 52, 0)',
                borderColor: 'rgba(0, 10, 52, 0)'
              },
              emphasis: {
                areaColor: 'rgba(0, 10, 52, 0)',
                borderColor: 'rgba(0, 10, 52, 0)'
              }
            }],
            z: 2
          },
          {
            map: 'china',
            aspectScale: 0.75,
            selectedMode: false,
            layoutCenter: ["50%", "55.5%"], //地图位置
            layoutSize: '110%',
            roam: false,
            itemStyle: {
              normal: {
                borderColor: '#c8fcfe',
                borderWidth: 4,
                // opacity: 1,
                areaColor: '#c8fcfe'
              },
              emphasis: {
                areaColor: '#c8fcfe',
                borderColor: '#c8fcfe',
                borderWidth: 4,
              }
            },
            regions: [{
              name: '南海诸岛',
              itemStyle: {
                areaColor: 'rgba(0, 10, 52, 1)',
                borderColor: 'rgba(0, 10, 52, 1)'
              },
              emphasis: {
                areaColor: 'rgba(0, 10, 52, 1)',
                borderColor: 'rgba(0, 10, 52, 1)'
              }
            }],
            z: 3
          }
        ],
        series: [{
          type: 'map',
          map: 'china',
          label: {
            show: true,
            color: '#FFFFFF',
            fontSize: 12,
            fontWeight: 300
          },
          selectedMode: 'single',
          select: {
            itemStyle: {
              areaColor: '#31e6f0',
              shadowColor: "#31e6f0",
              shadowOffsetY: 1,
              shadowBlur: 8,
              color: '#fff'
            }
          },
          data: that.mapData,
          aspectScale: 0.75,
          layoutCenter: ["50%", "55.5%"], //地图位置
          layoutSize: '110%',
          roam: false,
          itemStyle: {
            normal: {
              borderColor: '#4170a3',
              borderWidth: 0.8,
              // areaColor: '#142a5e',
              areaColor: {
                image: img, // 支持为 HTMLImageElement, HTMLCanvasElement，不支持路径字符串
                repeat: 'repeat' // 是否平铺, 可以是 'repeat-x', 'repeat-y', 'no-repeat'
              },
            },
            emphasis: {
              areaColor: '#31e6f0'
            }
          },
          zlevel: 5
        }]
      }
      setTimeout(() => {
        myChart.setOption(option)
      }, 200);
      window.addEventListener('resize', myChart.resize);
      myChart.on('click', function (params) {
        console.log(params)
        that.name = params.name
        const citys = ['新疆', '内蒙古', '西藏', '澳门', '香港', '南海诸岛']
        that.currentCity = citys.includes(params.name) ? params.name : params.name + '省'
        that.currentData = { '广东省': that.allData.guangdong, '湖南省': that.allData.hunan, '湖北省': that.allData.hubei }[that.currentCity] || that.allData.quanguo
        that.chart1()
        that.chart2()
        that.chart3()
        that.chart4()
        that.tip_show = true
        if (['广东省', '湖北省', '湖南省'].includes(that.currentCity)) {
          that.tip.project = that.currentData.project.count
          that.tip.device = that.currentData.project.device
        } else {
          that.tip.project = 0
          that.tip.device = 0
        }
        const { offsetX, offsetY } = params.event;
        that.$nextTick(() => {
          const el = document.getElementById('tooltip')
          el.style.left =
            offsetX + (-125 / 1920) * document.documentElement.clientWidth + 'px'
          el.style.top =
            offsetY - (220 / 1080) * document.documentElement.clientHeight + 'px'
        })
      })
    },

  },
}
</script>

<style lang="less" scoped>
::v-deep .el-tree {
  background: transparent;
  color: #fff;
  font-family: Source Han Sans CN;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  .custom-tree-node {
    display: flex;

    align-items: center;
  }
  .el-tree-node__content {
    display: flex;
    align-items: center;
    background: transparent;
  }
  .is-current {
    background: #254067 !important;
  }
  .el-tree-node__content:hover,
  .el-upload-list__item:hover {
    background: transparent !important;
  }
}
//分页
::v-deep .el-pagination {
  .btn-prev,
  .btn-next {
    border: 1px solid #0f81eb;
    background: transparent;
    color: #fff;
  }
  .more {
    background: #063676;
    border: 1px solid #0f81eb;
  }
  .el-pagination__editor .el-input__inner {
    background: #063676 !important;
  }
  .el-pager {
    .number {
      background: #063676 !important;
      border: 1px solid #0f81eb;
      margin: 0 6px;
      color: #fff;
      font-family: Source Han Sans CN;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px; /* 142.857% */
    }
    .active {
      border: none;
      background: #0f81eb !important;
      color: #fff !important;
      font-family: Source Han Sans CN;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px; /* 142.857% */
    }
  }
  .el-pagination__total,
  .el-pagination__jump {
    color: #0f81eb;
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }
  float: right;
  .el-icon-d-arrow-right,
  .el-icon-d-arrow-left {
    color: #0f81eb !important;
  }
  .el-icon-more {
    color: #0f81eb !important;
  }
  .btn-prev:hover,
  .btn-next:hover {
    color: #0f81eb !important;
  }
  .el-pagination__sizes {
    .el-input__inner {
      &:hover {
        border-color: #0f81eb !important;
      }
    }
  }
}
@import "../assets/font/font.css";
::v-deep .el-dialog {
  border-radius: 5px;
  border: 1px solid #5696e7;
  background: linear-gradient(180deg, #0c1734 0%, #04245a 100%);
  .el-dialog__title {
    // margin-left: 20px;
    color: #fff;
    font-family: YouSheBiaoTiHei;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .el-dialog__close {
    display: flex;
    align-items: center;
    font-size: 22px;
    color: #5696e7;
  }
  .el-dialog__body {
    padding: 0 20px 20px 20px;
  }
}
.dialog_workData {
  .dialog_container {
    height: 771px;
    .count-top {
      height: 93px;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      .tag {
        position: relative;
        width: 195px;
        height: 100%;
        > div {
          position: absolute;
          right: 26px;
          top: 34px;
          z-index: 10;
          span {
            display: block;
          }
          span:nth-child(1) {
            color: #fff;
            font-family: YouSheBiaoTiHei;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
          span:nth-child(2) {
            color: #fff;
            // margin-left: 25px;
            /* 标题投影 */
            text-shadow: 0px 5px 19px #0f81eb;
            font-family: DINPro;
            font-size: 20px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            span {
              font-family: DINPro;
              display: inline-block;
              font-size: 12px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
            }
          }
        }
      }
      #tag {
        background: url("../assets/gongdanzongshu.png") 0 0 no-repeat;
        background-size: 100%;
      }
      #tag1 {
        background: url("../assets/daijiedan.png") 0 0 no-repeat;
        background-size: 100%;
      }
      #tag2 {
        background: url("../assets/chulizhong.png") 0 0 no-repeat;
        background-size: 100%;
      }
      #tag3 {
        background: url("../assets/daichuli.png") 0 0 no-repeat;
        background-size: 100%;
      }
      #tag4 {
        background: url("../assets/yiwancheng.png") 0 0 no-repeat;
        background-size: 100%;
      }
      #tag5 {
        background: url("../assets/yiguanbi.png") 0 0 no-repeat;
        background-size: 100%;
      }
    }
  }
  ::v-deep .table {
    margin-top: 32px;
    .el-table {
      background: transparent;
    }
    .el-table__header-wrapper .el-table__header {
      th.el-table__cell {
        height: 38px;
        border-bottom: 1px solid #0f81eb;
        background: linear-gradient(180deg, #0c417e, #0d63b9);
        color: #fff;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
      }
    }
    .el-table__body-wrapper {
      height: 670px;
      overflow: auto;
      .el-table__cell {
        border-bottom: 1px solid #0f81eb;
        background: rgba(108, 128, 151, 0.1);
        color: #fff;
        text-align: center;
        font-family: Source Han Sans CN;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 157.143% */
      }
      tr:hover .el-table__cell {
        cursor: pointer;
      }
      .el-table__row--striped {
        .el-table__cell {
          background: rgba(108, 128, 151, 0.1);
        }
      }
      /* 滚动条整体部分 */
      &::-webkit-scrollbar {
        width: 10px;
      }
      /* 滚动条的轨道（里面装有Thumb） */
      &::-webkit-scrollbar-track {
        border-radius: 5px;
      }
      /* 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条） */
      &::-webkit-scrollbar-thumb {
        border-radius: 8px;
        box-shadow: 8px 10px 20px #08d4cb inset;
        border: 3px solid rgba(0, 0, 0, 0);
      }
      /* 滚动条里面的小方块鼠标移入时的样式 */
      &::-webkit-scrollbar-thumb:hover {
        width: 14px;
        box-shadow: 5px 10px 20px #06a79e inset;
      }
    }
    .el-table__row {
      height: 38px;
      color: #fff;

      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */
    }
  }
}
.dialog,
.dialog1 {
  .dialog_container {
    overflow: hidden;

    .filter {
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
    }
  }
}
.dialog2 {
  .dialog_t {
    color: #fff;
    font-family: YouSheBiaoTiHei;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .dialog_container {
    display: flex;
    margin-top: 20px;
    padding-bottom: 60px;
    .title {
      margin-bottom: 20px;
      display: flex;
      width: 116px;
      height: 27px;
      padding: 0px 10px;
      color: #fff;
      font-family: YouSheBiaoTiHei;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      background: linear-gradient(90deg, #0e70ce 0%, rgba(19, 115, 93, 0) 100%);
    }
    .flow {
      width: 280px;
      ::v-deep .flowItems {
        // border: 1px solid red;
        height: 420px;
        width: 100%;
        overflow: auto;
        /* 滚动条整体部分 */
        &::-webkit-scrollbar {
          width: 10px;
        }
        /* 滚动条的轨道（里面装有Thumb） */
        &::-webkit-scrollbar-track {
          border-radius: 5px;
        }
        /* 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条） */
        &::-webkit-scrollbar-thumb {
          border-radius: 8px;
          box-shadow: 8px 10px 20px #08d4cb inset;
          border: 3px solid rgba(0, 0, 0, 0);
        }
        /* 滚动条里面的小方块鼠标移入时的样式 */
        &::-webkit-scrollbar-thumb:hover {
          width: 14px;
          box-shadow: 5px 10px 20px #06a79e inset;
        }

        .el-timeline {
          padding-left: 5px;
          padding-top: 10px;
          .el-timeline-item__tail {
            border-left: 1px solid #777777;
            left: 3px;
          }
          .el-timeline-item {
            padding-bottom: 10px;
          }
          .el-timeline-item__node {
            width: 9px;
            height: 9px;
            border-radius: 50%;
          }
          .flow_container {
            display: flex;
            width: 210px;
            height: 59px;
            padding: 0px 10px;
            align-items: center;
            align-content: center;
            gap: 6px 15px;
            color: #fff;

            font-size: 14px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
            flex-shrink: 0;
            flex-wrap: wrap;
            border-radius: 2px;
            border: 2px solid #0f81eb;
            background: radial-gradient(
              588.73% 52.52% at 47.73% 50.85%,
              rgba(0, 199, 193, 0) 0%,
              rgba(0, 199, 193, 0.21) 100%
            );
          }
        }
      }
    }
    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      .title {
        // margin-left: 20px;
      }
      .info_container {
        flex: 1;
        padding-top: 20px;
        background: linear-gradient(
          180deg,
          rgba(15, 129, 235, 0.5) -26.96%,
          rgba(15, 129, 235, 0) 111.52%
        );
        padding-left: 20px;
        div {
          margin-bottom: 20px;
          color: #fff;

          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          max-width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.dialog3 {
  // position: relative;
  .time {
    position: absolute;
    left: 80px;
    top: 80px;
    color: #fff;
    font-family: DINPro;
    font-weight: 400;
    font-size: 26px;
  }
  .dialog_container {
    position: relative;
    height: 740px;
    margin: 0 auto;
    padding-top: 12px;
    display: flex;
    .tab {
      width: 244px;
      height: 680px;
      margin-right: 20px;
      background: url("../assets/nav_bg.png") 0 0 no-repeat;
      background-size: 100% 100%;
      background-position: 0 0;
      .nav {
        display: flex;
        padding: 0 55px;
        justify-content: space-between;
        margin-top: 24px;
        margin-bottom: 10px;
        div {
          color: #fff;
          /* 标题投影 */
          text-shadow: 0px 5px 19px #0f81eb;
          font-family: YouSheBiaoTiHei;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          position: relative;
        }
        .active {
          &::before {
            content: "";
            width: 30px;
            height: 2px;
            position: absolute;
            bottom: -5px;
            left: 50%;
            transform: translateX(-50%);
            background: #31e6f0;
          }
        }
      }
      ::v-deep .search {
        .el-input__inner {
          background: transparent;
          margin-left: 10px;
          width: 224px;
          height: 24px;
          margin-top: 10px;
          border-radius: 0;
          &::placeholder {
            color: rgba(255, 255, 255, 0.3);
            font-family: Source Han Sans CN;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
        }
      }
      .tree {
        margin: 0 10px;
        margin-top: 20px;
        height: 573px;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 0;
        }
      }
    }
    .monitorList {
      flex: 1;
      height: 680px;
      // border: 1px solid red;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .name {
        height: 40px;
        width: 100%;
        background: rgba(25, 39, 69, 0.5);
        position: absolute;
        bottom: 0;
        left: 0;
        line-height: 40px;
        text-indent: 40px;
        color: #fff;
        font-family: Source Han Sans CN;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
      }
      .video {
        width: 586px;
        height: 330px;
        position: relative;
        .time {
          position: absolute;
          left: 20px;
          top: 20px;
          color: #fff;
          font-family: DINPro;
          font-weight: 400;
          font-size: 20px;
        }
        &:nth-child(3) {
          margin-top: 20px;
        }
        &:nth-child(4) {
          margin-top: 20px;
        }
      }
    }
    .monitorList1 {
      flex: 1;
      height: 680px;
      position: relative;
      .time {
        position: absolute;
        left: 40px;
        top: 40px;
        color: #fff;
        font-family: DINPro;
        font-weight: 400;
        font-size: 26px;
      }
      video {
        width: 100%;
        height: 100%;
      }
    }
  }
  .pagination {
    position: absolute;
    bottom: 15px;
    right: 20px;
  }
}
.main {
  padding-top: 113px;
  padding-bottom: 20px;
  height: 100%;
  .header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 91px;
    z-index: 9999;
    // border: 1px solid red;
    background: transparent;
    color: #fff;
    text-shadow: 0px 5px 19px #0f81eb;
    font-family: YouSheBiaoTiHei;
    font-size: 48px;
    font-style: normal;
    font-weight: 400;
    line-height: 91px;
    letter-spacing: 26.64px;
    text-align: center;
    background: url("@/assets/header.png") 0 0 no-repeat;
    background-size: 100% 100%;
    .date {
      position: absolute;
      right: 19px;
      top: 14px;
      width: 280px;
      display: flex;
      justify-content: space-around;
      img {
        width: 15px;
        height: 15px;
      }
      .content {
        color: #fff;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 2px;
      }
    }
  }
  .container {
    display: flex;
    width: 100%;
    height: 100%;
    .fd-c {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .title,
    .title-c {
      padding-left: 20px;
      color: #fff;

      /* 标题投影 */
      text-shadow: 0px 5px 19px #0f81eb;
      font-family: YouSheBiaoTiHei;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px;
      .more {
        float: right;
        margin-right: 10px;
        line-height: 36px;
        color: rgba(255, 255, 255, 0.5);

        /* 标题投影 */
        text-shadow: 0px 5px 19px #0f81eb;
        font-family: Source Han Sans SC;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        cursor: pointer;
      }
    }
    .title {
      height: 36px;
      margin-bottom: 10px;
      background: url("../assets/title_bg.png");
    }
    .title-c {
      height: 36px;
      margin-bottom: 10px;
      background: url("../assets/title_c_bg.png");
    }
    .content {
      flex: 1;
      // border: 1px solid red;
    }
    .left {
      width: 440px;
      height: 100%;
      margin-right: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .device,
      .ai,
      .alarm {
        .content {
          background: linear-gradient(
            180deg,
            rgba(15, 129, 235, 0.5) -26.96%,
            rgba(15, 129, 235, 0) 111.52%
          );
        }
        &::after {
          position: absolute;
          bottom: 0;
          height: 2px;
          width: 100%;
          content: "";
          background: url("../assets/bottom1.png") 0 0 no-repeat;
        }
      }
      .device {
        height: 276px;
        margin-bottom: 20px;
        position: relative;
        .content {
          display: flex;
          padding-left: 13px;
          #pie {
            width: 228px;
            height: 100%;
            background: url("@/assets/pie_bg.png") -4px -4px no-repeat;
            background-size: 104% 104%;
          }
          .lis {
            padding: 50px 0;
            flex: 1;
            padding-left: 10px;
            display: flex;
            flex-direction: column;
            // align-items: center;
            justify-content: space-around;
            li {
              color: #fff;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              list-style: none;
              width: 155px;
              height: 25px;
              // margin-bottom: 34px;
              background: url("@/assets/bottomLine.png") no-repeat;
              background-position: bottom left;
              background-size: 100%;
              text-indent: 11px;
              position: relative;
              &::before {
                content: "";
                position: absolute;
                left: -2.55px;
                top: 50%;
                transform: translateY(-70%);
                width: 8px;
                height: 8px;
              }
              &:nth-child(1) {
                & > span {
                  background: linear-gradient(180deg, #ddf1ff 0%, #8bbaff 100%);
                  background-clip: text;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                }
                &::before {
                  background: #31e6f0;
                }
              }
              &:nth-child(2) {
                & > span {
                  background: linear-gradient(180deg, #ddf1ff 0%, #8bbaff 100%);
                  background-clip: text;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                }
                &::before {
                  background: #00a6ff;
                }
              }
              &:nth-child(3) {
                & > span {
                  background: linear-gradient(180deg, #ddf1ff 0%, #8bbaff 100%);
                  background-clip: text;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                }
                &::before {
                  background: #00a6ff;
                }
              }
              & > span {
                float: right;
                font-family: DIN;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                line-height: 16px;

                span {
                  padding-left: 5px;
                  color: #fff;
                  background: #fff;
                  background-clip: text;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;

                  font-size: 10px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                }
              }
            }
          }
        }
      }
      .ai {
        height: 281px;
        margin-bottom: 20px;
        position: relative;
      }
      .alarm {
        flex: 1;
        position: relative;
      }
    }
    .center {
      margin-right: 20px;
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        position: relative;
        .count-top {
          height: 93px;
          width: 100%;
          position: absolute;
          top: 0;
          // border: 1px solid red;
          display: flex;
          justify-content: space-between;
          .tag {
            position: relative;
            // background-color: #fff;
            width: 196px;
            overflow: hidden;
            height: 100%;
            transform: translate3d(0, 0, 0);
            // border: 1px solid red;
            > div {
              position: absolute;
              right: 20px;
              top: 27px;
              z-index: 10;
              span {
                display: block;
              }
              span:nth-child(1) {
                color: #fff;
                font-family: YouSheBiaoTiHei;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
              span:nth-child(2) {
                color: #fff;
                // margin-left: 25px;
                /* 标题投影 */
                text-shadow: 0px 5px 19px #0f81eb;
                font-family: DINPro;
                font-size: 20px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                span {
                  font-family: DINPro;
                  display: inline-block;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                }
              }
            }
          }
        }

        flex: 1;
        .img_1 {
          width: 6px;
          height: 36px;
          position: absolute;
          top: 111px;
          left: 0;
        }
        .img_2 {
          width: 10px;
          height: 54px;
          position: absolute;
          bottom: 0;
          right: 0;
        }
        .point {
          color: rgba(255, 255, 255, 0.5);
          font-family: YouSheBiaoTiHei;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          position: absolute;
          left: 31px;
          top: 111px;
          span:nth-child(2) {
            color: #fff;

            /* 标题投影 */
            text-shadow: 0px 5px 19px #0f81eb;
            font-family: YouSheBiaoTiHei;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            position: relative;
            margin-left: 6px;
            &::after {
              content: "";
              position: absolute;
              bottom: -3px;
              left: 50%;
              width: 20px;
              height: 2px;

              background: #31e6f0;
              transform: translateX(-50%);
            }
          }
        }
        .count-b {
          padding: 8px;
          width: 140px;
          height: 128px;
          position: absolute;
          bottom: 0;
          left: 0;
          background: url("../assets/c_img_3.png") 0 0 no-repeat;
          background-size: 100%;
          .monitor {
            display: flex;
            img {
              width: 40px;
              // height: 22.345px;
            }
            > div {
              display: flex;
              flex-direction: column;
              span:nth-child(1) {
                color: #18e2f5;
                text-align: left;
                font-family: DINPro;
                font-size: 20px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
              }
              span:nth-child(2) {
                color: #fff;
                font-family: Source Han Sans SC;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
            }
          }
          .li {
            margin-top: 8px;
            margin-left: 3px;
            color: #fff;
            font-family: Source Han Sans CN;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            width: 120px;
            height: 25px;
            // margin-bottom: 34px;
            background: url("../assets/bottomLine.png") no-repeat;
            background-position: bottom left;
            text-indent: 12px;
            position: relative;
            &::before {
              content: "";
              position: absolute;
              left: -3.5px;
              top: 50%;
              transform: translateY(-70%);
              width: 8px;
              height: 8px;
            }

            &:nth-child(2) {
              & > span {
                background: linear-gradient(180deg, #ddf1ff 0%, #8bbaff 100%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &::before {
                background: #31e6f0;
              }
            }
            &:nth-child(3) {
              & > span {
                background: linear-gradient(180deg, #ddf1ff 0%, #8bbaff 100%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &::before {
                background: #c2c2c2;
              }
            }
            & > span {
              float: right;
              font-family: DIN;
              font-size: 18px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;

              > span {
                // padding-left: 5px;
                color: #fff;
                font-family: Source Han Sans CN;
                font-size: 10px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
            }
          }
        }
        .map {
          height: 100%;
          // border: 1px solid red;
        }
        .tooltip {
          position: absolute;
          padding: 20px;
          width: 240px;
          height: 184px;
          top: 100px;
          left: 200px;
          z-index: 9999;
          background: url("@/assets/tooltip.png") 0 0 no-repeat;
          background-size: 100% 100%;
          .close {
            position: absolute;
            right: 10px;
            top: 20px;
            width: 20px;
            height: 20px;
            cursor: pointer;
          }
          .city {
            color: #fff;
            /* 标题投影 */
            text-shadow: 0px 5px 19px #0f81eb;
            font-family: YouSheBiaoTiHei;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
          .label {
            margin-top: 10px;
            display: flex;
            color: #7babd7;
            font-family: Source Code Pro;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            span:nth-child(1) {
              width: 90px;
            }
            span:nth-child(2) {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .value1 {
              color: #0dffff;
              font-family: DINPro;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              line-height: 16px; /* 100% */
            }
            .value2 {
              color: #fff;
              font-family: DINPro;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              line-height: 16px; /* 100% */
            }
            .value3 {
              color: #fff;
              font-family: Source Han Sans CN;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 16px; /* 133.333% */
            }
          }
        }
      }
      .bottom {
        margin-top: 10px;
        height: 285px;
        position: relative;
        .content {
          display: flex;
          background: linear-gradient(
            180deg,
            rgba(15, 129, 235, 0.5) -26.96%,
            rgba(15, 129, 235, 0) 111.52%
          );
          .count {
            margin: 10px;
            width: 172px;
            height: 100%;
            background: url("@/assets/workFlow_bg.png") 0 0 no-repeat;
            display: flex;
            flex-direction: column;
            .count_t {
              margin: 5px 0 0 10px;
              color: #fff;
              /* 标题投影 */
              // text-shadow: 0px 5px 19px #0f81eb;
              font-family: YouSheBiaoTiHei;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
            .lis {
              padding: 25px 0 50px;
              flex: 1;
              // padding-left: 10px;
              display: flex;
              flex-direction: column;
              // align-items: center;
              justify-content: space-between;
              align-items: center;
              li {
                color: #fff;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                list-style: none;
                width: 143px;
                height: 25px;
                // margin-bottom: 34px;
                background: url("@/assets/bottomLine.png") no-repeat;
                background-position: bottom left;
                background-size: 100%;
                text-indent: 11px;
                position: relative;
                &::before {
                  content: "";
                  position: absolute;
                  left: -2.55px;
                  top: 50%;
                  transform: translateY(-70%);
                  width: 8px;
                  height: 8px;
                }
                &:nth-child(1) {
                  & > span {
                    background: linear-gradient(
                      180deg,
                      #ddf1ff 0%,
                      #8bbaff 100%
                    );
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                  }
                  &::before {
                    background: #31e6f0;
                  }
                }
                &:nth-child(2) {
                  & > span {
                    background: linear-gradient(
                      180deg,
                      #ddf1ff 0%,
                      #8bbaff 100%
                    );
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                  }
                  &::before {
                    background: #00a6ff;
                  }
                }
                &:nth-child(3) {
                  & > span {
                    background: linear-gradient(
                      180deg,
                      #ddf1ff 0%,
                      #8bbaff 100%
                    );
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                  }
                  &::before {
                    background: #00a6ff;
                  }
                }
                & > span {
                  float: right;
                  font-family: DIN;
                  font-size: 18px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: normal;
                  line-height: 16px;

                  span {
                    padding-left: 5px;
                    color: #fff;
                    background: #fff;
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;

                    font-size: 10px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                  }
                }
              }
            }
          }
          ::v-deep .table {
            flex: 1;
            // border: 1px solid red;
            padding-top: 10px;
            padding-right: 10px;
            .el-table__body-wrapper {
              height: 180px;
              overflow: auto;
            }
          }
        }
        &::after {
          position: absolute;
          bottom: 0;
          height: 2px;
          width: 100%;
          content: "";
          background: url("../assets/bottom2.png") 0 0 no-repeat;
        }
      }
    }
    .right {
      width: 440px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .task,
      .warn,
      .monitor {
        position: relative;
        .content {
          background: linear-gradient(
            180deg,
            rgba(15, 129, 235, 0.5) -26.96%,
            rgba(15, 129, 235, 0) 111.52%
          );
        }
        &::after {
          position: absolute;
          bottom: 0;
          height: 2px;
          width: 100%;
          content: "";
          background: url("../assets/bottom1.png") 0 0 no-repeat;
        }
      }
      .task {
        height: 276px;
        margin-bottom: 20px;
      }
      .warn {
        height: 346px;
        margin-bottom: 20px;
        .content {
          display: flex;
          flex-direction: column;
          .top {
            height: 74px;
            display: flex;
            .alarm_c {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 30px;
                height: 39.261px;
              }
              div {
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                span {
                  color: #fff;
                  font-family: Source Code Pro;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                }
              }
            }
            .lis {
              padding: 9px 0;
              flex: 2;
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              div {
                width: 50%;
                color: #fff;
                font-family: Source Code Pro;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                text-indent: 30px;
                position: relative;
                &::before {
                  content: "";
                  position: absolute;
                  left: 2%;
                  top: 50%;
                  transform: translateY(-50%);
                  width: 12px;
                  height: 12px;
                }
                &::after {
                  content: "";
                  position: absolute;
                  left: calc(2% + 4px);
                  top: calc(50%);
                  transform: translateY(-50%);
                  width: 6px;
                  height: 6px;
                }
                &:nth-of-type(1)::before {
                  border: 1px solid #134f92;
                }
                &:nth-of-type(1)::after {
                  background: #2d87f0;
                }
                &:nth-of-type(2)::before {
                  border: 1px solid #475655;
                }
                &:nth-of-type(2)::after {
                  background: #d99d2a;
                }
                &:nth-of-type(3)::before {
                  border: 1px solid #0f5e81;
                }
                &:nth-of-type(3)::after {
                  background: #1ebdc8;
                }
                &:nth-of-type(4)::before {
                  border: 1px solid #213f8a;
                }
                &:nth-of-type(4)::after {
                  background: #5956ea;
                }
              }
            }
          }
          .bottom {
            flex: 1;
            // border: 1px solid red;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom: 20px;
            div {
              margin: 0 10px;
              height: 42px;
              border-radius: 1px;
              opacity: 0.5;
              background: rgba(15, 129, 235, 0.1);
              display: flex;
              align-items: center;
              opacity: 1;
              .item_t {
                padding: 0 10px;
                color: #fff;
                flex: 1;
                font-family: Source Code Pro;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
              .bar {
                width: 242px;
                height: 6px;
                background: #101625;
                position: relative;
                &::before {
                  content: "";
                  left: 0;
                  top: 0;
                  position: absolute;

                  height: 100%;
                }
              }
              .bar1::before {
                width: 22%;
                background: linear-gradient(
                  to right,
                  #101625,
                  #1d5aa3 70%,
                  #c1dcfb
                );
              }
              .bar2::before {
                width: 12%;
                background: linear-gradient(
                  to right,
                  #101625,
                  #15707b 70%,
                  #c1dcfb
                );
              }
              .bar3::before {
                width: 5%;
                background: linear-gradient(
                  to right,
                  #101625,
                  #ab7e26 70%,
                  #c1dcfb
                );
              }
              .bar4::before {
                width: 61%;
                background: linear-gradient(
                  to right,
                  #101625,
                  #2725ab 70%,
                  #c1dcfb
                );
              }
              .guangdong1::before {
                width: 18%;
              }
              .hubei1::before {
                width: 25%;
              }
              .hunan1::before {
                width: 33%;
              }
              .guangdong2::before {
                width: 18%;
              }
              .hubei2::before {
                width: 0%;
              }
              .hunan2::before {
                width: 0%;
              }
              .guangdong3::before {
                width: 10%;
              }
              .hubei3::before {
                width: 0;
              }
              .hunan3::before {
                width: 0;
              }
              .guangdong4::before {
                width: 54%;
              }
              .hubei4::before {
                width: 75%;
              }
              .hunan4::before {
                width: 67%;
              }
              .percent {
                width: 30px;
                margin: 0 10px;
                color: #e7f2ff;
                font-family: DINPro;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
              }
            }
          }
        }
      }
      .monitor {
        flex: 1;
        position: relative;
        .time {
          position: absolute;
          left: 10px;
          top: 10px;
          color: #fff;
          font-family: DINPro;
          font-weight: 400;
        }
        .content {
          padding-right: 30px;
          position: relative;
          #video {
            position: relative;
            width: 100%;
            height: 100%;
          }
          .video_t {
            height: 36px;
            background: rgba(25, 39, 69, 0.5);
            position: absolute;
            bottom: 0;
            width: 100%;
            padding: 0 10px 0 20px;
            display: flex;
            align-items: center;
            color: #fff;
            font-family: Source Han Sans CN;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            justify-content: space-between;
            img {
              cursor: pointer;
            }
          }
          .pagination {
            position: absolute;
            right: 10px;
            bottom: 10px;
            width: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            height: 60px;
            img {
              width: 10px;
              height: 10px;
              cursor: pointer;
            }
            .round {
              cursor: pointer;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: rgba(0, 166, 255, 0.4);
            }
            .active {
              background: #31e6f0;
            }
          }
        }
      }
    }
  }
}
</style>